import {
  AddRuleResponse,
  ChangeCategoryResult,
  DeleteRuleResponse,
  GetConfigurationResponse,
  GetItemPatternResult,
  GetMLStoresResponse,
  GetModelStatusResponse,
  GetRulesResponse,
  ListItemDetailsResult,
  ListMainItemsResult,
  ListSelectableItemsResponse,
  UpdateConfigurationResponse,
  UpdateStoreConfigurationResponse,
} from '../ml-service.types';

export const listMainItemsResult: ListMainItemsResult = {
  code: 0,
  message: 'success',
  mainItemCount: 23,
  mainItemNames: [
    'Almond Banana Toast',
    'Sub Vegan GlutenFree Green Tahini',
    'Sub Chimichanga',
    'Wheat Bun',
    'Mac Cheese',
    'Pizza Item 1',
    'Bacon Cheeseburger',
    'Pesto Tuna',
    'APPLE WALNUT SALAD',
    'Home Fries 16 Oz',
    'Italian Pizza',
    'Impossible Loco Moco Burger',
    'Caesar Salad dairy',
    'Deep River Salt Pepper',
    'No Arugula',
    'Greens Mix Romaine Arugula Kale Cabbage',
    'Risotto Cakes w Braised Short Rib',
    'Garden Pesto',
    'California Club Wrap',
    'NO gyro meat',
    'Scoop out bagel',
    'Ham Egg Cheese on Bagel Sandwich',
    'Potato Salad',
  ],
};

export const getItemPattern: GetItemPatternResult = {
  clientId: '99ec1b0a-dabe-4e6d-9006-1ba3c870d2bf',
  itemName: 'OVEN ROASTED SALMON PLATE',
  popularItems: [
    {
      itemName: 'VEGAN WALNUT CHOCOLATE CHIP COOKIE',
      category: 'dessert',
      support: 0.08764940239043825,
    },
    {
      itemName: 'GF GUAVA COCONUT COOKIE',
      category: 'dessert',
      support: 0.07330677290836653,
    },
    {
      itemName: 'SIDE ITEM 0',
      category: 'side',
      support: 0.50482071713147411,
    },
    {
      itemName: 'SIDE ITEM 1',
      category: 'side',
      support: 0.0900398406374502,
    },
    {
      itemName: 'SIDE ITEM 2',
      category: 'side',
      support: 0.08924302788844622,
    },
    {
      itemName: 'SIDE ITEM 3',
      category: 'side',
      support: 0.0701195219123506,
    },
    {
      itemName: 'SIDE ITEM 4',
      category: 'side',
      support: 0.0653386454183267,
    },
    {
      itemName: 'WELCOME TO MIAMI',
      category: 'beverage',
      support: 0.08366533864541832,
    },
    {
      itemName: 'FLU SHOT',
      category: 'beverage',
      support: 0.06693227091633466,
    },
    {
      itemName: 'MIAMI MOCHA',
      category: 'beverage',
      support: 0.05657370517928287,
    },
    {
      itemName: 'IMMUNE BOOSTER',
      category: 'beverage',
      support: 0.05179282868525897,
    },
    {
      itemName: 'IMMUNITY SHOT',
      category: 'beverage',
      support: 0.05099601593625498,
    },
    {
      itemName: 'CHOCOLATE PB',
      category: 'modifier',
      support: 0.08286852589641434,
    },
    {
      itemName: 'VITAMIN SEA',
      category: 'modifier',
      support: 0.06932270916334661,
    },
    {
      itemName: 'ADD CUTLERY UTENSILS',
      category: 'modifier',
      support: 0.06454183266932272,
    },
    {
      itemName: 'EVIAN 500ml',
      category: 'modifier',
      support: 0.06374501992031872,
    },
    {
      itemName: 'JENS HERB',
      category: 'modifier',
      support: 0.06135458167330677,
    },
    {
      itemName: 'VEGAN ALMOND BUTTER ENERGY BITES',
      category: 'modifier',
      support: 0.050199203187251,
    },
  ],
  createdDate: '2024-09-18T20:49:29.765+00:00',
};

export const getRules: GetRulesResponse = {
  code: 0,
  message: 'success',
  rules: [
    {
      ruleId: '64a68fd730c27077e70dc393',
      ruleType: 'OR',
      triggerMenus: [],
      triggerGroups: [],
      triggerItems: ['CHICKEN PARM PANINI'],
      recommendationItems: [
        'Green tea',
        'Mexican Cola',
        'Iced Tea',
        'Lemonade',
      ],
    },
    {
      ruleId: '64a68fd730c27077e70dc392',
      ruleType: 'OR',
      triggerMenus: [],
      triggerGroups: [],
      triggerItems: ['Fish Panini'],
      recommendationItems: ['Mexican Coca Cola'],
    },
  ],
};

export const listItemDetailsResult: ListItemDetailsResult = {
  itemDetails: [
    {
      itemId: '60ddcd2ef774090d13f801e7',
      externalId: '6161',
      itemName: 'Almond Banana Toast',
      category: 'main',
      subCategory: 'Entrees',
    },
    {
      category: 'modifier',
      externalId: '211mi',
      itemId: '5d92e81ef7740929e21d68d9',
      itemName: 'Add Red Cabbage',
      subCategory: 'modifier',
    },
    {
      category: 'side',
      externalId: 'c62a0f0d-5bfd-4726-a8f2-826cc61ea890',
      itemId: '6246f89de4b0695b3dfa30c2',
      itemName: '12 Piece Wings',
      subCategory: 'side',
    },
    {
      itemId: '618062b5e4b06b398bdd20ba',
      externalId: '5747d6e4-505f-4cf7-86d8-29fe8b8c5b15',
      itemName: 'Kaleifornia WShrimp',
      category: 'beverage',
      subCategory: 'beverage',
    },
  ],
};

export const changeCategoryResult: ChangeCategoryResult = {
  category: 'dessert',
  clientId: '99ec1b0a-dabe-4e6d-9006-1ba3c870d2bf',
  itemName: 'Almond Banana Toast',
  previousCategory: 'main',
  previousSubCategory: 'Entrees',
  subCategory: 'dessert',
};

export const createRuleResponse: AddRuleResponse = {
  code: 0,
  message: 'success',
  ruleCount: 1,
};

export const deleteRuleResponse: DeleteRuleResponse = {
  code: 0,
  message: 'success',
};

export const listSelectableItemsResponse: ListSelectableItemsResponse = {
  code: 0,
  message: 'success',
  itemCount: 4,
  groupCount: 4,
  menuCount: 4,
  items: ['Item 0', 'Item 1', 'Item 2', 'Item 3'],
  groups: ['Group 0', 'Group 1', 'Group 2', 'Group 3'],
  menus: ['Menu 0', 'Menu 1', 'Menu 2', 'Menu 3'],
};

export const getModelStatusResponse: GetModelStatusResponse = {
  code: 0,
  message: null,
  transactionCount: '7753',
  modelReady: 1,
  lastTrainedDate: '2025-10-18T06:24:42.301+00:00',
};

export const getConfigurationResponse: GetConfigurationResponse = {
  code: 0,
  message: 'success',
  mainCount: 4,
  sideCount: 5,
  beverageCount: 1,
  dessertCount: 2,
  maxRuleRecommendations: 3,
  maxRecommendations: 10,
};

export const updateConfigurationResponse: UpdateConfigurationResponse = {
  code: 0,
  message: 'success',
  newSideCount: 3,
  newBeverageCount: 3,
  newDessertCount: 5,
  newModifierCount: 3,
  newMaxRecommendations: 10,
};

export const updateStoreConfigurationResponse: UpdateStoreConfigurationResponse =
  {
    code: 0,
    message: 'success',
    updatedLocationsCount: 143,
  };

export const getMLStoresResponse: GetMLStoresResponse = {
  code: 0,
  message: 'success',
  locations: [
    {
      locationId: 'store0',
      locationName: 'Store 0',
      locationEnabled: true,
    },
    {
      locationId: 'store1',
      locationName: 'Store 1',
      locationEnabled: false,
    },
  ],
};
